// Sentry first, so it is listening before anything else can throw (src/instrument.ts).
import './instrument'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// React 18: a render error anywhere is reported and replaced by this, not a blank page.
function Crashed() {
  return (
    <div className="grid min-h-screen place-items-center p-6 text-center">
      <div>
        <p className="text-base font-semibold text-slate-900">Something went wrong on this page.</p>
        <p className="mt-1 text-sm text-slate-500">It has been reported. Reloading usually fixes it.</p>
        <button onClick={() => window.location.reload()}
          className="mt-4 rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white">Reload</button>
      </div>
    </div>
  )
}

/*
 * WHICH SKIN THIS INSTALLATION WEARS.
 *
 * The decision is made by the host the page was served from rather than by a build: one
 * bundle, and a practice can never be given a new look because somebody deployed the wrong
 * artefact. Removing a hostname from this list returns that site to the original in one line,
 * which is exactly what happened to the two live practices on 12 October 2026: they are back
 * on the original blue at the owner's request, and the demo keeps Ledger.
 *
 * ⚠️ app.lynqpod.com IS NOT HERE AND NEVER WAS. The console has always been the original
 * blue, which is the look the practices have now gone back to.
 */
const LEDGER_HOSTS = ['demo.lynqpod.com']
if (LEDGER_HOSTS.includes(window.location.hostname)) {
  document.documentElement.setAttribute('data-theme', 'ledger')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<Crashed />}><App /></Sentry.ErrorBoundary>
  </StrictMode>,
)
